module.exports = __webpack_public_path__ + "static/media/13.9f9bc4b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/13.jpg
// module id = 188
// module chunks = 0